import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=80635b42&scoped=true"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=80635b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80635b42",
  null
  
)

export default component.exports